import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExamComponent } from './exam/exam.component';
import { LoginComponent } from './login/login.component';
import { PatientsComponent } from './patients/patients.component';
import {PatexamsComponent} from './patexams/patexams.component';
import { PrintComponent } from './print/print.component';
import {RemotevideoComponent} from './remotevideo/remotevideo.component';
import { CardioPrintComponent } from './cardio/cardio-print/cardio-print.component';
import { GastroPrintComponent } from './Gastro/gastro-print/gastro-print.component';
import { GsprintFormComponent } from './Gastro/gsprint-form/gsprint-form.component';
import { CustomheaderComponent } from './customheader/customheader.component';
import { StatsComponent } from './stats/stats.component';
import { PrintstatsComponent } from './Gastro/printstats/printstats.component';
import { SearchtextComponent } from './searchtext/searchtext.component';
import { PrintreportComponent } from './printreport/printreport.component';
import { PrintcalendarComponent } from './printcalendar/printcalendar.component';
import { PrintPathologyFormComponent } from './print-pathology-form/print-pathology-form.component';
import { WaitingListComponent } from './waiting-list/waiting-list.component';
import { LabresultsComponent } from './labresults/labresults.component';  
import { BiopsystatsComponent } from './biopsystats/biopsystats.component';
import { MessengerReportComponent } from './messenger-report/messenger-report.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: 'exam', component: ExamComponent },
  {path: 'patsearch', component: PatientsComponent},
  {path: 'exams', component: PatexamsComponent },
  {path: 'defaults', component: PatexamsComponent },
  {path: 'Custom', component: CustomheaderComponent },
  {path: 'Stats', component: StatsComponent },
  // {path: 'Searchdata', component: SearchtextComponent }, // old code from aweb pre hospital split

  {path: '', component: LoginComponent},
//----------------------------Gastro Exam Print Start--------------------------------------------------------------------------------//
  {path: 'gastroprint/:examid/:PID/:LANG/:charts/:images/:style', component: GastroPrintComponent},
  {path: 'gastroprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: GastroPrintComponent},
  {path: 'gastroprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: GastroPrintComponent},
  {path: 'gastroprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: GastroPrintComponent},


  {path: 'statprint/:LANG/:style/:return/:type/:dates/:start/:end/:searchByType', component: PrintstatsComponent},
  {path: 'statprint/:LANG/:style/:return/:type/:dates/:start/:end/:searchByType/:code', component: PrintstatsComponent},
  
  {path: 'reportprint/:isReport/:type/:start/:end/:hmo', component: PrintreportComponent},
  {path: 'reportprint/:isReport/:type/:start/:end/:hmo/:code', component: PrintreportComponent},

  {path: 'printCalendar/:pregID', component: PrintcalendarComponent},
  {path: 'printCalendar/:pregID/:code', component: PrintcalendarComponent},

  {path: 'printPathologyForm/:examId', component: PrintPathologyFormComponent},
  {path: 'labresults', component: LabresultsComponent},
  {path: 'biopsystats', component: BiopsystatsComponent},

  {path: 'printMessengerReport/:lab/:reportid', component: MessengerReportComponent},
  {path: 'printMessengerReport/:lab/:reportid/:code', component: MessengerReportComponent},



//----------------------------Gastro Exam Print End--------------------------------------------------------------------------------//

//----------------------------Gastro Form Print Start--------------------------------------------------------------------------------//
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: GsprintFormComponent},
{path: 'gastroprintform/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader/:gsform', component: GsprintFormComponent},

//----------------------------Gastro Form Print End--------------------------------------------------------------------------------//

  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: CardioPrintComponent},
  {path: 'cardioprint/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: CardioPrintComponent},

  
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style:/perpage', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: PrintComponent},
  {path: 'print/:examid/:PID/:LANG/:charts/:images/:style/:perpage/:code/:showheader', component: PrintComponent},

  // TABLET GUI
  {path: 'tablet', component:WaitingListComponent },
  

  {path: 'videoserver', component: RemotevideoComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent}
];

import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from './custom-url-serializer';

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
    onSameUrlNavigation: 'reload',
    canceledNavigationResolution: 'replace',
    urlUpdateStrategy: 'deferred'
  })],
  exports: [RouterModule],
  providers: [{ provide: UrlSerializer, useClass: CustomUrlSerializer }]
})
export class AppRoutingModule { }
